import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import { Router, useRouter } from "../../helper-functions/useRouterReplacement";
import { setConfigData } from "../../redux/slices/configData";
import StoreDetails from "../../components/store-details";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";
import { useParams } from "react-router-dom";
import useGetStoreDetails from "../../api-manage/hooks/react-query/store/useGetStoreDetails";

const Index = ({ id: propId, moduleId, distance, storeZoneId }) => {
  const { configData, landingPageData, loading } = useConfigData();
  const dispatch = useDispatch();
  const router = useRouter();
  const { id: paramId } = useParams();
  const storeId = propId || paramId;
  const [isSSR, setIsSSR] = useState(true);
  
  const { data: storeDetails, refetch, isLoading: storeLoading } = useGetStoreDetails(storeId);

  useEffect(() => {
    setIsSSR(false);
    if (configData) {
      if (configData.length === 0) {
        router.push("/404");
      }
      else if(configData?.maintenance_mode){
        router.push("/maintainance");
      }
      else {
        dispatch(setConfigData(configData));
      }
    }
  }, [configData, dispatch, router]);

  useEffect(() => {
    if (storeId && configData) {
      refetch();
    }
  }, [storeId, configData, refetch]);

  if (loading || storeLoading) {
    return <SplashScreen />;
  }

  const metaTitle = `${storeDetails?.name} - ${configData?.business_name}`;

  return (
    <>
      {!isSSR && (
        <>
          <CssBaseline />
          <SEO
            title={metaTitle}
            image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
            businessName={configData?.business_name}
          />
          <MainLayout configData={configData} landingPageData={landingPageData}>
            <StoreDetails 
              storeDetails={storeDetails} 
              configData={configData} 
              storeId={storeId}
              moduleId={moduleId}
              distance={distance}
              storeZoneId={storeZoneId}
            />
          </MainLayout>
        </>
      )}
    </>
  );
};

export default Index;
